// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3tbrq","brand":"Footer_brand__4TJNt","menu":"Footer_menu__uFqDS","footerLink":"Footer_footerLink__1dF0l","menuItem":"Footer_menuItem__2htWJ"};